export default "__VITE_ASSET__BHOPwe16__"